var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolume(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6001 4.99414C15.1893 5.88485 15.5025 6.93015 15.5001 7.9986C15.5013 9.06543 15.192 10.1095 14.6101 11.0031",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 5.99547V10.0014C1 10.5326 1.21071 11.0421 1.58579 11.4177C1.96086 11.7934 2.46957 12.0044 3 12.0044H4L6.78 14.3879C7.15163 14.7049 7.60601 14.9089 8.08959 14.9759C8.57316 15.0428 9.06576 14.9698 9.50931 14.7656C9.95285 14.5614 10.3289 14.2345 10.593 13.8233C10.8571 13.4122 10.9983 12.9339 11 12.445V3.56186C10.9977 3.07205 10.8559 2.59305 10.5913 2.18113C10.3266 1.76921 9.95013 1.44148 9.50596 1.23641C9.06179 1.03135 8.56841 0.957476 8.08378 1.02347C7.59914 1.08946 7.14337 1.29258 6.77 1.60897L4 3.9925H3C2.46957 3.9925 1.96086 4.20353 1.58579 4.57916C1.21071 4.95479 1 5.46425 1 5.99547Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolume);
export default __webpack_public_path__ + "static/media/volume.886f9443259f5330ddf62397f02b63b0.svg";
export { ForwardRef as ReactComponent };